import { TTextLocalized } from '@northladder/utilities';

/**
 * Extracts the English value from a localized text object.
 */
function extractEnglishValue(
  text: TTextLocalized | null | undefined
): string | null {
  if (!text) return null;

  if (typeof text === 'string') return text;

  return (text as { en?: string }).en || null;
}

/**
 * Checks if the device is a Samsung device.
 * First checks brandName if provided, otherwise checks productName/label.
 */
export function isSamsungDevice(
  productName: TTextLocalized | null | undefined,
  brandName?: TTextLocalized | null
): boolean {
  if (brandName) {
    const brandNameEnglish = extractEnglishValue(brandName);

    if (brandNameEnglish) {
      return brandNameEnglish.toLowerCase().includes('samsung');
    }
  }

  const deviceNameEnglish = extractEnglishValue(productName);

  if (!deviceNameEnglish) return false;

  return deviceNameEnglish.toLowerCase().includes('samsung');
}
